export default "__VITE_ASSET__54bxiK1S__"